import React, { useEffect, useState } from 'react';
import {
  getCustomerById,
  createCustomerTeamMember,
  updateCustomerTeamMember,
  markCustomerTeamMemberInactive,
} from '../service';
import { getCustomerInvoices } from '../../invoice/service';
import { getCustomerSubscriptions } from '../../subscription/service';
import { handleAPIError } from '../../../utils/apiUtils';
// import { CUSTOMERBYID_MOCK, SUBSCRIPTIONS_MOCK, INVOICES_MOCK } from '../constants';

const useCustomerDetail = (customerId) => {
  const [customer, setCustomer] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  const sortAndSetTeamMembers = (teamList) => {
    teamList.sort((a, b) => {
      if (a.is_active !== b.is_active) {
        return b.is_active - a.is_active;
      }

      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
    setCustomer({ ...customer, team: teamList});
  }

  const addOrUpdateTeamMember = async (customerTeam) => {
    let response = {
      success: false,
      code: null,
      message: null,
    };

    try {
      if (customerTeam.id) {
        const updated = await updateCustomerTeamMember(customerTeam.id, customerTeam);
        const updatedCustomer = customer.team.map(c => (c.id === updated.id ? updated : c));
        sortAndSetTeamMembers(updatedCustomer);
        response.success = true;
      } else {
        const created = await createCustomerTeamMember(customerTeam);
        const updatedCustomer = [...customer.team, created];
        sortAndSetTeamMembers(updatedCustomer);
        response.success = true;
      }
      getCustomerById(customerId);
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to add or update customer Team member', error);
    }
    return response;
  };

  const markTeamMemberInactive = async (id, date) => {
    try {
      await markCustomerTeamMemberInactive(id, date, customerId);
      const updatedCustomer = customer.team.map(c => 
        c.id === id ? { ...c, is_active: !c.is_active, last_deactivation_date: date} : c
      );
      sortAndSetTeamMembers(updatedCustomer);
    } catch (error) {
      console.error('Failed to mark inactive the customer team member', error);
    }
  }


  useEffect(() => {
    const loadAll = async () => {
      try {
        setLoading(true);
        const [cust, subs, invs] = await Promise.all([
          getCustomerById(customerId),
          getCustomerSubscriptions(customerId),
          getCustomerInvoices(customerId),
        ]);
        setCustomer(cust);
        setSubscriptions(subs?.subscription_items || []);
        setInvoices(invs);
      } catch (err) {
        console.error('Customer detail load error:', err);
        // setCustomer(CUSTOMERBYID_MOCK);
        // setSubscriptions(SUBSCRIPTIONS_MOCK);
        // setInvoices(INVOICES_MOCK);
      } finally {
        setLoading(false);
      }
    };

    if (customerId) {
      loadAll();
    }
  }, [customerId]);

  return { customer, subscriptions, invoices, loading, addOrUpdateTeamMember, markTeamMemberInactive };
};

export default useCustomerDetail;
